export default "__VITE_ASSET__CY8YyNv6__"